/**
 * Remembers what was on screen so a phone call doesn't cost you your place.
 *
 * Mobile browsers discard the tab when memory gets tight; coming back is a
 * cold boot and the user lands on the dashboard. We keep a breadcrumb of the
 * open tab, project and sheet in localStorage (sessionStorage does not
 * survive that kill) and replay it on the next load.
 *
 * Expires after 12 hours so yesterday's sheet never ambushes anyone.
 */

const KEY = 'ui:last-screen';
const MAX_AGE_MS = 12 * 60 * 60 * 1000;

export function loadSession() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!raw || !raw.at || Date.now() - raw.at > MAX_AGE_MS) return null;
    return raw;
  } catch {
    return null;
  }
}

export function patchSession(patch) {
  try {
    const current = loadSession() || {};
    localStorage.setItem(KEY, JSON.stringify({ ...current, ...patch, at: Date.now() }));
  } catch { /* private mode / storage full */ }
}

export function clearSession() {
  try { localStorage.removeItem(KEY); } catch { /* nothing to do */ }
}
